export const tr = {
    gteMessage: 'Günlük bütçe miktarı maksimum {maxValue} olabilir',
    lteMessage: 'Günlük bütçe miktarı minimum {minValue} olabilir',
    requiredMessage: 'Günlük bütçe miktarı belirtilmedi'
};
